export const updateTokenEvent = (accessToken: string) => {
  const event = {
    type: "update_token",
    accessToken,
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(event));
};
